import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://ipo-backend-a9sl.onrender.com';

/**
 * Resolve a backend-relative path (e.g. "/static/...") to an absolute URL
 * @param {string} path - Relative or absolute URL
 */
export const resolveApiUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${BASE_URL.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
};

export const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Response interceptor for unified response handling
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    const message =
      data?.message ||
      data?.error ||
      data?.detail?.error || // FastAPI HTTPException shape
      error.message ||
      'An unexpected network error occurred';
    const normalized = new Error(message);
    // Lets callers tell a 404 (e.g. unknown company) apart from network failures
    normalized.status = error.response?.status;
    return Promise.reject(normalized);
  }
);

export default axiosClient;
